let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6pdbo"), load("ePOyH"), load("1epse"), load("9cZwe")]).then(() => parcelRequire('4bY0V'));